import { TEALLIUM_COOKIE_KEY, TEALLIUM_USER_ID } from '@/logic/main/constants';
import Cookies from '@/ports-frontend/Cookie';

export const fetchTealiumUserId = async () => {
  const cookie = ((await Cookies.get(TEALLIUM_COOKIE_KEY)) || '').split(
    /[;$]/gm
  );
  if (!cookie || !cookie.length) return { tealiumUserId: undefined };
  const mappedCookie: Record<string, string> = cookie.reduce((acc, curr) => {
    const splitted = curr.split(':');
    return Object.assign(acc, { [splitted[0]]: splitted[1] });
  }, {});

  return {
    tealiumUserId: mappedCookie[TEALLIUM_USER_ID],
  };
};
